import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCarFrontView: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"car-front-view"} maskId="square-filled-radius-0-stroke-1-IconCarFrontView"><path fillRule="evenodd" clipRule="evenodd" d="M6.23241 4L2.23241 10H1V11H2V20H6V18H18V20H22V10.75H23V9.75H21.6009L17.7676 4H6.23241ZM8 14H5V13H8V14ZM16 14H19V13H16V14Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCarFrontView;
